import dayjs from 'dayjs';

import { delCookie, getCookie, setCookie } from '@webapp/common/lib/cookies';
import { appendSearchParam, deleteSearchParam } from '@webapp/common/lib/search-params';

import { getSearchParams } from './get-search-params';

export const TT_ID = 'tt_id';

export const tryToGetTtId = (): string | undefined =>
    (getSearchParams()?.[TT_ID] ?? getCookie(TT_ID)) as string | undefined;

export const setTtId = (newTtId: string) => {
    setTimeout(() => {
        appendSearchParam(TT_ID, newTtId);
    }, 100);
    setCookie(TT_ID, newTtId, {
        expires: dayjs().add(100, 'year').toDate(),
    });
};

export const clearTtId = () => {
    deleteSearchParam(TT_ID);
    delCookie(TT_ID);
};
